import script from "./RoomView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomView.vue?vue&type=script&setup=true&lang=js"

import "./RoomView.vue?vue&type=style&index=0&id=0092b545&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0092b545"]])

export default __exports__